import * as types from '../constants/actionTypes';

export function changeTempData(amendments){
  return { type : types.CHANGE_TEMP_DATA , amendments }
}

export function changeUiState(amendments){
  return { type : types.CHANGE_UI_STATE , amendments }
}

export function clearState(){
  return { type : types.CLEAR_STATE }
}

export function changeLanguage(locale){
  return { type : types.SETTING_LANGUAGE , value : locale }
}



/** WEBPACK FOOTER **
 ** ./src/actions/uiActions.js
 **/